<template>
  <div class="container is-fluid">
    <div class="box has-background-light">
      <div class="level">
        <div class="level-left">
          <h5 class="title is-5 has-text-primary">Gerenciar Grupos de Indicadores</h5>
        </div>
        <div class="level-right">
          <button class="button is-primary is-rounded is-small" @click="add()">
            <span class="icon is-small">
              <i class="fas fa-plus"></i>
            </span>
            <span>Cadastrar</span>
          </button>
        </div>
      </div>
    </div>

    <div class="modal" :class="{ 'is-active': isShowModal }">
      <div class="modal-background" @click="isShowModal = false"></div>
      <div class="modal-card" style="width: 600px;">
        <header class="modal-card-head has-background-primary">
          <p class="modal-card-title has-text-white">Cadastrar Grupo de Indicadores</p>
          <button class="delete" aria-label="close" @click="isShowModal = false"></button>
        </header>
        <section class="modal-card-body">
          <form v-if="!mostraIndicadores && !mostraCompartilhamento">
            <div class="field">
              <label class="label is-small">Descrição</label>
              <div class="control">
                <input
                  class="input is-small"
                  type="text"
                  placeholder="Informe a descrição do balanço patrimonial"
                  v-model="grupoIndicador.descricao"
                >
              </div>
            </div>

            <div class="field">
              <label class="label is-small">Comentários</label>
              <div class="control">
                <textarea
                  class="textarea is-small"
                  placeholder="Comente sobre esse balanço patrimonial"
                  v-model="grupoIndicador.comentario"
                ></textarea>
              </div>
            </div>

            <div class="field">
              <label class="label is-small">Dashboard?</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="grupoIndicador.dashboard">
                    <option value="1">Sim</option>
                    <option value="2">Não</option>
                  </select>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraCompartilhamento">
            <div class="field">
              <label class="label is-small">Versão</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="grupoIndicadorCompartilhar.versao_plano_contas">
                    <option
                      v-for="versao_plano_contas in versoesPlanoContas"
                      :key="versao_plano_contas.id"
                      :value="versao_plano_contas"
                    >
                      {{ versao_plano_contas.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraIndicadores">
            <div class="field">
              <label class="label is-small">Descrição</label>
              <div class="control">
                <input
                  class="input is-small"
                  type="text"
                  placeholder="Informe a descrição da versão do plano de contas"
                  v-model="indicador.descricao"
                >
              </div>
            </div>

            <div class="field">
              <label class="label is-small">Índice</label>
              <div class="control">
                <input class="input is-small" type="text" v-model="indicador.indice">
              </div>
            </div>

            <div class="field">
              <label class="label is-small">Desejada</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="indicador.tipo_evolucao_desejada">
                    <option value="A">Alta</option>
                    <option value="B">Baixa</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="field">
              <label class="label is-small">Fórmula</label>
              <div class="control">
                <textarea
                  class="textarea is-small"
                  placeholder="Informe a fórmula para preenchimento"
                  v-model="indicador.formula"
                ></textarea>
              </div>
            </div>

            <div class="field">
              <label class="label is-small">Comentário</label>
              <div class="control">
                <textarea
                  class="textarea is-small"
                  placeholder="Informe um comentário"
                  v-model="indicador.comentario"
                ></textarea>
              </div>
            </div>

            <div class="field">
              <label class="label is-small">Fator de Apresentação</label>
              <div class="control">
                <input
                  class="input is-small"
                  type="text"
                  v-model="indicador.fator_apresentacao"
                >
              </div>
            </div>

            <div class="field">
              <label class="label is-small">Dashboard?</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select
                    v-model="indicador.dashboard"
                    :disabled="indicador.grupo_indicador.dashboard == false"
                  >
                    <option value="1">Sim</option>
                    <option value="2">Não</option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success is-rounded is-small" @click="save()">Salvar</button>
          <button class="button is-rounded is-small" @click="isShowModal = false">Cancelar</button>
        </footer>
      </div>
    </div>

    <div class="columns">
      <div class="column is-two-fifths">
        <div class="card">
          <header class="card-header has-background-primary has-text-white">
            <p class="card-header-title has-text-white">Grupos de Indicadores</p>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-striped is-narrow is-hoverable is-fullwidth">
                <thead>
                  <tr class="has-background-grey-lighter">
                    <th class="is-size-7">Descrição</th>
                    <th class="is-size-7 has-text-centered" colspan="4">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(gi, index) in gruposIndicadores" :key="gi.id">
                    <td class="is-size-7">{{ gi.descricao }}</td>
                    <td class="has-text-centered">
                      <button
                        class="button is-small is-info is-outlined"
                        data-tooltip="Editar"
                        @click="edit(index)"
                        :disabled="mostraCompartilhamento || mostraIndicadores"
                      >
                        <span class="icon is-small">
                          <i class="fas fa-edit"></i>
                        </span>
                      </button>
                    </td>
                    <td class="has-text-centered">
                      <button
                        class="button is-small is-danger is-outlined"
                        data-tooltip="Excluir"
                        @click="erase(index)"
                        :disabled="mostraCompartilhamento || mostraIndicadores"
                      >
                        <span class="icon is-small">
                          <i class="fas fa-trash-alt"></i>
                        </span>
                      </button>
                    </td>
                    <td class="has-text-centered">
                      <button
                        class="button is-small is-primary is-outlined"
                        data-tooltip="Compartilhar"
                        @click="callCompartilhamento(gi)"
                        :disabled="mostraCompartilhamento || mostraIndicadores"
                      >
                        <span class="icon is-small">
                          <i class="fas fa-share-alt"></i>
                        </span>
                      </button>
                    </td>
                    <td class="has-text-centered">
                      <button
                        class="button is-small is-success is-outlined"
                        data-tooltip="Indicadores"
                        @click="callIndicador(gi)"
                        :disabled="mostraCompartilhamento || mostraIndicadores"
                      >
                        <span class="icon is-small">
                          <i class="fas fa-th-list"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="column" v-show="mostraCompartilhamento">
        <div class="card">
          <header class="card-header has-background-grey has-text-white">
            <p class="card-header-title has-text-white">
              Compartilhar {{ grupoIndicadorSelecionado.descricao }}
            </p>
            <a class="card-header-icon" @click="mostraCompartilhamento = false">
              <span class="icon has-text-white">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-narrow is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr class="has-background-grey-lighter">
                    <th class="is-size-7 has-text-left">Versão</th>
                    <th class="is-size-7 has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(gi, index) in grupoIndicadorVersoes" :key="gi.id">
                    <td class="is-size-7 has-text-left">{{ gi.versao_plano_contas.descricao }}</td>
                    <td class="has-text-centered">
                      <button
                        class="button is-small is-danger is-outlined"
                        data-tooltip="Excluir"
                        @click="erase(index)"
                      >
                        <span class="icon is-small">
                          <i class="fas fa-trash-alt"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraCompartilhamento = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>

      <div class="column" v-show="mostraIndicadores">
        <div class="card">
          <header class="card-header has-background-grey has-text-white">
            <p class="card-header-title has-text-white">
              Indicadores do Grupo {{ grupoIndicadorSelecionado.descricao }}
            </p>
            <a class="card-header-icon" @click="mostraIndicadores = false">
              <span class="icon has-text-white">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-narrow is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr class="has-background-grey-lighter">
                    <th class="is-size-7 has-text-left">Índice</th>
                    <th class="is-size-7 has-text-left">Indicador</th>
                    <th class="is-size-7 has-text-left">Comentário</th>
                    <th class="is-size-7 has-text-centered" colspan="2">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ind, index) in indicadores" :key="ind.id">
                    <td class="is-size-7 has-text-left">{{ ind.indice }}</td>
                    <td class="is-size-7 has-text-left">{{ ind.descricao }}</td>
                    <td class="is-size-7 has-text-left">{{ ind.comentario }}</td>
                    <td class="has-text-centered">
                      <button
                        class="button is-small is-info is-outlined"
                        data-tooltip="Editar"
                        @click="edit(index)"
                      >
                        <span class="icon is-small">
                          <i class="fas fa-edit"></i>
                        </span>
                      </button>
                      <button class="button is-small is-success is-outlined" @click="abrirFormulas(ind)" title="Fórmula do perfil">
                        <span class="icon is-small">
                          <i class="fas fa-calculator"></i>
                        </span>
                      </button>
                    </td>
                    <td class="has-text-centered">
                      <button
                        class="button is-small is-danger is-outlined"
                        data-tooltip="Excluir"
                        @click="erase(index)"
                      >
                        <span class="icon is-small">
                          <i class="fas fa-trash-alt"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraIndicadores = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>
    </div>
    
    <indicador-formula-perfil v-if="linhaSelecionada" :key="linhaSelecionada.id" :visivel="mostrarFormulas" :linha="linhaSelecionada" @fechar="fecharFormulas"/>

  </div>
</template>

<script>
    import {http} from '../../services/config'
    import IndicadorFormulaPerfil from './IndicadorFormulaPerfil.vue'

    export default {
        name: "GrupoIndicador",

        components: { IndicadorFormulaPerfil },        

        data(){
            return{
                grupoIndicador: {
                    id: null,
                    descricao: null,
                    comentario: null,
                    usuario: null,
                    dashboard: "1"
                },
                grupoIndicadorCompartilhar: { id: null,
                    grupo_indicador: null,
                    versao_plano_contas: null
                },
                indicador: {
                    id: null,
                    grupo_indicador: {
                        id: null,
                        descricao: null,
                        comentario: null,
                        usuario: null,
                        dashboard: "1"
                    },
                    usuario: null,
                    descricao: null,
                    indice: "N",
                    formula: null,
                    comentario: null,
                    tipo_evolucao_desejada: null,
                    fator_apresentacao: 1,
                    dashboard: "1"
                },
                versoesPlanoContas: [],
                perfisUsuario: [],
                gruposIndicadores: [],
                grupoIndicadorVersoes: [],
                indicadores: [],
                isShowModal: false,
                mostraIndicadores: false, 
                mostraCompartilhamento: false,
                grupoIndicadorSelecionado: {
                    id: null,
                    descricao: null,
                    dashboard: null
                },
                previous: null,
                next: null,
                page: null,
                numpages: null,
                mostrarFormulas: false,
                linhaSelecionada: null }
        },

        methods: {
            abrirFormulas(linha) {
              this.linhaSelecionada = linha;
              this.mostrarFormulas = true;
            },       
            
            fecharFormulas() {
              this.mostrarFormulas = false;
              this.linhaSelecionada = null;
            },            
            add: function() {
                this.clearFields()
                this.isShowModal = true              
            },

            edit: function(index){
                if (!this.mostraIndicadores && !this.mostraCompartilhamento) {
                    this.grupoIndicador.id = this.gruposIndicadores[index].id
                    this.grupoIndicador.descricao = this.gruposIndicadores[index].descricao
                    this.grupoIndicador.comentario = this.gruposIndicadores[index].comentario

                    if (this.gruposIndicadores[index].dashboard) {
                        this.grupoIndicador.dashboard = "1"
                    } else {
                        this.grupoIndicador.dashboard = "2"
                    }

                    this.grupoIndicador.index = index
                } 
                else {
                    this.indicador.id = this.indicadores[index].id
                    this.indicador.grupo_indicador = this.grupoIndicadorSelecionado
                    this.indicador.usuario = this.$store.state.idUser
                    this.indicador.descricao = this.indicadores[index].descricao
                    this.indicador.indice = this.indicadores[index].indice
                    this.indicador.formula = this.indicadores[index].formula
                    this.indicador.comentario = this.indicadores[index].comentario
                    this.indicador.tipo_evolucao_desejada = this.indicadores[index].tipo_evolucao_desejada
                    this.indicador.fator_apresentacao = this.indicadores[index].fator_apresentacao

                    if (this.indicadores[index].dashboard) {
                        this.indicador.dashboard = "1"
                    } else {
                        this.indicador.dashboard = "2"
                    }

                    this.indicador.index = index

                }
                this.isShowModal = true
            },

            erase: function(index){
                if (window.confirm('Confirma exclusão?')) {
                    if (!this.mostraIndicadores && !this.mostraCompartilhamento) {
                        http.delete('/grupoIndicador/excluir/'+this.gruposIndicadores[index].id).then(response =>{
                            this.gruposIndicadores.splice(index, 1)
                            if (response.status == 204) {
                                alert('Registro excluído!')
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    } else if (this.mostraCompartilhamento) {
                        http.delete('/grupoIndicador/excluirVersoes/'+this.grupoIndicadorVersoes[index].id).then(response =>{
                            this.grupoIndicadorVersoes.splice(index, 1)
                            if (response.status == 204) {
                                alert('Registro excluído!')
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    }
                    else {
                        http.delete('/indicador/excluir/'+this.indicadores[index].id).then(response =>{
                            this.indicadores.splice(index, 1)
                            if (response.status == 204) {
                                alert('Registro excluído!')
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    }
                }
            },

            callCompartilhamento: function(grpIndicador) {
                this.mostraCompartilhamento = true
                this.grupoIndicadorSelecionado = grpIndicador
                http.get('grupoIndicador/listarVersoes/', {params: {
                    idGrupoIndicador: this.grupoIndicadorSelecionado.id
                }}).then(response => {
                    this.grupoIndicadorVersoes = response.data.results
                })
            },

            clearFields: function() {
                if (!this.mostraIndicadores && !this.mostraCompartilhamento) {
                    this.grupoIndicador = { id: null,
                    descricao: null,
                    comentario: null,
                    usuario: null,
                    dashboard: "1",
                    index: null }
                } else if (this.mostraCompartilhamento) {
                    this.grupoIndicadorCompartilhar = {id: null,
                        grupo_indicador: null,
                        versao_plano_contas: null }
                } else {
                    this.indicador = {
                        id: null,
                        usuario: this.$store.state.idUser,
                        descricao: null,
                        indice: null,
                        formula: null,
                        comentario: null,
                        grupo_indicador: this.grupoIndicadorSelecionado,
                        tipo_evolucao_desejada: null,
                        fator_apresentacao: 1,
                        dashboard: this.grupoIndicadorSelecionado.dashboard,
                        index: null
                    }
                    
                    if (!this.indicador.dashboard) {
                        this.indicador.dashboard = "2"
                    } else {
                        this.indicador.dashboard = "1"
                    }
                }
            },

            callIndicador: function(grpIndicador) {
                this.mostraIndicadores = true
                this.grupoIndicadorSelecionado = grpIndicador
                http.get('indicador/listar/', {params: {
                    idGrupoIndicador: this.grupoIndicadorSelecionado.id}}).then(response => {
                    this.indicadores = response.data.results
                })
            },

            save: function(){
                var data

                if (!this.mostraIndicadores && !this.mostraCompartilhamento) {
                    if (this.grupoIndicador.descricao == null) {
                        alert('Descrição do grupo de indicadores não preenchida!')
                        return
                    }

                    data = {id: this.grupoIndicador.id,
                        usuario: this.$store.state.idUser,
                        descricao: this.grupoIndicador.descricao,
                        comentario: this.grupoIndicador.comentario,
                        dashboard: true
                    }

                    if (this.grupoIndicador.dashboard == "1") {
                        data.dashboard = true
                    } else {
                        data.dashboard = false
                    }

                    let formData = new FormData()

                    formData.append('id', data.id)
                    formData.append('usuario', data.usuario)
                    formData.append('descricao', data.descricao)
                    formData.append('comentario', data.comentario)
                    formData.append('dashboard', data.dashboard)

                    if (this.grupoIndicador.id == null) {
                        http.post('/grupoIndicador/adicionar', formData).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.grupoIndicador.id = response.data.id
                                this.gruposIndicadores.push(this.grupoIndicador)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            console.log(e);
                        })

                    } 
                    else {
                        http.put('/grupoIndicador/editar/'+this.grupoIndicador.id, formData).then(response =>{
                            this.gruposIndicadores[this.grupoIndicador.index].descricao = response.data.descricao
                            this.gruposIndicadores[this.grupoIndicador.index].comentario = this.grupoIndicador.comentario
                            if (this.grupoIndicador.dashboard == "1") {
                                this.gruposIndicadores[this.grupoIndicador.index].dashboard = true
                            } else {
                                this.gruposIndicadores[this.grupoIndicador.index].dashboard = false
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    }
                } else if (this.mostraCompartilhamento) {
                    if (this.grupoIndicadorCompartilhar.versao_plano_contas == null) {
                        alert('Versão não informada!')
                        return
                    }

                    data = {id: this.grupoIndicadorCompartilhar.id,
                        grupo_indicador: this.grupoIndicadorSelecionado.id,
                        versao_plano_contas: this.grupoIndicadorCompartilhar.versao_plano_contas.id
                    }

                    if (this.grupoIndicadorCompartilhar.id == null) {
                        http.post('/grupoIndicador/adicionarVersoes', data).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.grupoIndicadorCompartilhar.id = response.data.id
                                this.grupoIndicadorVersoes.push(this.grupoIndicadorCompartilhar)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    } 
                } else {
                    if (this.indicador.descricao == null) {
                        alert('Descrição da linha não informada!')
                        return
                    }

                    if (this.indicador.indice == null) {
                        alert('Índice não informado!')
                        return
                    }

                    if (this.indicador.formula == null) {
                        alert('Fórmula do indicador não informada!')
                        return
                    }

                    if (this.indicador.fator_apresentacao == null || this.indicador.fator_apresentacao == 0 || this.indicador.fator_apresentacao == "") {
                        alert('Fator de apresentação não informado!')
                        return
                    }

                    data = {id: this.indicador.id,
                        grupo_indicador: this.grupoIndicadorSelecionado.id,
                        usuario: this.$store.state.idUser,
                        descricao: this.indicador.descricao,
                        indice: this.indicador.indice,
                        formula: this.indicador.formula,
                        comentario: this.indicador.comentario,
                        tipo_evolucao_desejada: this.indicador.tipo_evolucao_desejada,
                        fator_apresentacao: this.indicador.fator_apresentacao,
                        dashboard: true
                    }

                    if (this.indicador.dashboard == "1") {
                        data.dashboard = true
                    } else {
                        data.dashboard = false
                    }

                    // Tratar erro constratint da UK

                    if (this.indicador.id == null) {
                        http.post('/indicador/adicionar', data).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.indicador.id = response.data.id
                                this.indicadores.push(this.indicador)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    } 
                    else {
                        http.put('/indicador/editar/'+this.indicador.id, data).then(response =>{
                            this.indicadores[this.indicador.index].descricao = response.data.descricao
                            this.indicadores[this.indicador.index].indice = response.data.indice
                            this.indicadores[this.indicador.index].formula = response.data.formula
                            this.indicadores[this.indicador.index].fator_apresentacao = response.data.fator_apresentacao
                            this.indicadores[this.indicador.index].comentario = response.data.comentario
                            this.indicadores[this.indicador.index].tipo_evolucao_desejada = response.data.tipo_evolucao_desejada
                            this.indicadores[this.indicador.index].grupo_indicador = this.grupoIndicadorSelecionado

                            if (this.indicador.dashboard == "1") {
                                this.indicadores[this.indicador.index].dashboard = true
                            } else {
                                this.indicadores[this.indicador.index].dashboard = false
                            }

                            this.indicadores[this.indicador.index].usuario = this.$store.state.idUser
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    }                    
                }

            },
        },

        mounted: function() {
        },
        
        created: function() {
            http.get('compartilharPerfis/listarPerfis').then(response => {
                this.perfisUsuario = response.data.results
            })

            http.get('versoesPlanoContas/listar').then(response => {
                this.versoesPlanoContas = response.data.results
            })

            http.get('grupoIndicador/listar/').then(response => {
                this.gruposIndicadores = response.data.results
                this.previous = response.data.previous
                this.next = response.data.next
                this.page = response.data.page
                this.numpages = response.data.numpages
            })
        }    
    }
</script>

<style scoped>
</style>